import { RETRY } from '@src/constants/retry'
import pRetryMain, { Options } from 'p-retry'
import * as R from 'ramda'

export const pRetry = async (
  operation: pRetryOperation,
  options: Options = RETRY.DEFAULT
) => {
  await pRetryMain(async () => {
    try {
      return operation()
    } catch (e) {
      throw R.is(Error, e) ? e : new Error(R.propOr('', 'message', e))
    }
  }, options)
}

type pRetryOperation = () => Promise<void>
